module.exports = __webpack_public_path__ + "img/io.3ddd1280.svg";